
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/button",
      function () {
        return require("private-next-pages/design-system/button.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/button"])
      });
    }
  